import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import ExceptionFeedback from '@app/components/common/Exception/ExceptionFeedback';
import { FEEDBACK_TYPES } from '@app/constants/errorConstants';
import useConflictNotes from '../../hooks/useConflictNotes';
import ModalButtonCTA from '../../buttons/ModalButtonCTA';
import InfoText from '../../../InfoText';
import { CloseIcon } from 'cat-ecommerce-alloy';

const CancelMergeModal = ({ close, parentModalClose }) => {
  const { t } = useTranslation();
  const { onCloseDispatch } = useConflictNotes();
  const onYesCancelClick = () => {
    onCloseDispatch(parentModalClose);
  };

  const CancelMergeTexts = {
    title: t('CANCEL_MERGE_MESSAGE'),
    className: 'u-color--DarkGray u-fs--16 my-3'
  };

  return (
    <div className="mb-4">
      <ExceptionFeedback preventScroll type={FEEDBACK_TYPES.WARNING}>
        <p className="u-color--DarkGray">{t('CANCEL_MERGE_WARNING_MESSAGE')}</p>
      </ExceptionFeedback>
      <InfoText data={CancelMergeTexts} />
      <div className="d-flex flex-md-row-reverse flex-column">
        <ModalButtonCTA
          btnTitle={t('YES_CANCEL')}
          btnType="secondary"
          size="dynamic"
          onClick={onYesCancelClick}
        />
        <ModalButtonCTA
          btnTitle={t('BACK')}
          btnType="ghost"
          size="dynamic"
          onClick={() => close()}
          icon={CloseIcon}
          className="me-3 mt-3 mt-md-0 d-flex justify-content-center align-items-center"
        />
      </div>
    </div>
  );
};

CancelMergeModal.propTypes = {
  close: PropTypes.func,
  parentModalClose: PropTypes.func
};

export default CancelMergeModal;
